import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'notasAlumnos'
})
export class NotasAlumnosPipe implements PipeTransform {

  transform(value: any, search: string, strict = false): any {
    if(!value) return []
    if(!search) return value
    const term = String(search).toLowerCase()
    return value.filter(item=> {
      const str = String(item.descripcion).toLowerCase()
      return strict ? str === term : !!~str.indexOf(term);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/filters/notas-alumnos.pipe.ts